import utilityFunctions from '@/utils/functions';
import * as moment from 'moment';

export default class {
/* eslint-disable */
  constructor(data, fromEdit) {
    const sessionEnd = data.sessionEnd ? data.sessionEnd.split('T')[1] : null;
    this.medicaid = [{ minutes: '', startTime: '', endTime: '', procedures: [], outcome: '' }];
    this.totalMedicaidMinutes = 0;
    this.totalReimbursableMinutes = data.medicaidMinutes || 0;
    if (data.medicaidSessions.length) {
      if (!fromEdit) {
        let p;
        this.medicaid = data.medicaidSessions.map((medicaid) => {
          // exclude values preventing copying the SL
          const { id, referenceId, referenceType, ...obj } = medicaid;
          if (obj && obj.procedures && obj.procedures.length) {
            p = obj.procedures.map((proc) => {
              // exclude values preventing copying the SL
              // eslint-disable-next-line no-shadow
              const { id, medicaidSessionId, ...m } = proc;
              return m;
            });
          }
          obj.procedures = p;
          return obj;
        });
      } else {
        this.medicaid = data.medicaidSessions;
      }
    }
    this.notes = data.notes;
    this.serviceInformation = {
      serviceStartDate: moment(data.serviceStartDate, 'YYYY-MM-DD').format('MM-DD-YYYY'),
      serviceEndDate: moment(data.serviceEndDate, 'YYYY-MM-DD').format('MM-DD-YYYY'),
      fullName: fromEdit ? data.providerFirstName + ' ' + data.providerLastName : data.providerFullName,
      providerFirstLastName: data.providerFirstName + ' ' + data.providerLastName,
      credentialName: data.providerCredential,
      credentialType: data.providerCredentialType,
      needLevel: data.needLevel,
      sessionDate:
        data.sessionDate ? utilityFunctions.formatDate(data.sessionDate) : null,
      militaryStartTime: data.sessionTime,
      militaryEndTime: sessionEnd,
      sessionTime: data.sessionTime || null,
      sessionTimeEnd: sessionEnd || null,
      sessionMinutes: data.sessionMinutes,
      location: data.location,
      locationOther: data.locationOther,
      deliveryMode: data.deliveryMode,
      roomName: data.roomName,
      notes: '',
      noShow: data.noShow,
      bus: data.bus,
      serviceDocumentation: '',
      licenseAttestFlag: data.licenseAttestFlag,
      licenseAttestUserId: data.licenseAttestUserId,
      licenseAttestDate: data.licenseAttestDate,
      supervisorUserId: data.supervisorUserId,
      supervisorName: data.supervisorName,
      supervisorDate: data.supervisorDate,
    };
    // capture submission metadata for comparison logic (e.g., updatedDate)
    this.updatedDate = data.updatedDate || null;
    this.createdDate = data.createdDate;
  }
}



// WEBPACK FOOTER //
// ./src/utils/service-log-class.js